import { useCallback, useMemo } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateRangePicker as MuiDateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { format, Locale, addYears } from "date-fns";
import { enUS } from "date-fns/locale/en-US";
import { useBannerState } from "shared/hooks";
import { RangePickerButton } from "./RangePickerButton";
import { makePopperStyles, Container } from "./DateRangePicker.styles";
import { useDateRangeContext } from "../../hooks";

const locale: Locale = {
  ...enUS,
  options: {
    weekStartsOn: 1
  }
};

export const DateRangePicker = () => {
  const { startDate, endDate, setDateRange } = useDateRangeContext();

  const { bannerHeight } = useBannerState();

  const minimumDate = useMemo(() => new Date("2016-01-01"), []);

  const maxDate = useMemo(() => {
    if (startDate) {
      return addYears(startDate, 7);
    }
  }, [startDate]);

  const handleDateRangeChange = useCallback((newValue: [Date | null, Date | null]) => {
    setDateRange(newValue);
  }, []);

  const formatDayOfWeek = useCallback((date: Date) => {
    return format(date, "EEEEEE").toUpperCase();
  }, []);

  return (
    <Container topOffset={bannerHeight}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        <MuiDateRangePicker
          slots={{
            field: RangePickerButton
          }}
          slotProps={{
            popper: {
              sx: makePopperStyles
            }
          }}
          showDaysOutsideCurrentMonth
          format="dd MMM yy"
          minDate={minimumDate}
          maxDate={maxDate}
          dayOfWeekFormatter={formatDayOfWeek}
          calendars={1}
          value={[startDate, endDate]}
          onChange={handleDateRangeChange}
        />
      </LocalizationProvider>
    </Container>
  );
};
